// ** React Imports
import React from 'react'

// ** MUI Imports
import { styled } from '@mui/material/styles'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// ** Styled Linear Progress
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#D9D9D9'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#478F96'
  }
}))

const ProcessLinearCustomization = ({ value }) => {
  return (
    <Box position='relative' display='flex' alignItems='center'>
      {/* Progress Bar */}
      <BorderLinearProgress
        variant='determinate'
        value={value}
        style={{ width: '100%', height: '15px' }}
      />

      {/* Text Overlay */}
      <Box
        position='absolute'
        left='10%'
        top='50%'
        style={{
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'flex-start', // Aligns items to flex-start
          justifyContent: 'flex-start', // Optionally center horizontally
        }}
      >
        <Typography variant='caption' component='div' color='textPrimary'>
          {`${Math.round(value)}%`}
        </Typography>
      </Box>

      {/* Gray Percentage */}
      <Box
        position='absolute'
        right='5%'
        top='50%'
        style={{
          transform: 'translateY(-50%)',
          pointerEvents: 'none'
        }}
      >
        <Typography variant='caption' component='div' color='textSecondary'>
         {value>0?`${Math.round(100-value)}%`:null} 
        </Typography>
      </Box>
    </Box>
  )
}

export default ProcessLinearCustomization
